import { IIconProps } from "../types"

export default function IconUR5(props: IIconProps) {
  const width = props.size || props.width || 64
  const height = props.size || props.height || 80
  return (
    <svg
      {...props}
      width={width}
      height={height}
      className={props.className}
      style={props.style}
      viewBox="0 0 64 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.1831 1.15194C27.8631 0.471944 31.5031 0.531945 34.6931 1.71194C37.8831 2.88194 40.6231 5.16194 43.3531 8.58194C46.0931 11.9919 48.8231 16.5519 51.7231 21.5619C54.6231 26.5819 57.6831 32.0519 59.6331 36.4419C61.5831 40.8319 62.4231 44.1519 62.8731 47.4419C63.3331 50.7319 63.4031 53.9919 62.5631 57.2419C61.7131 60.5019 59.9531 63.7519 57.9731 66.4819C55.9831 69.2219 53.7731 71.4319 50.7131 73.6119C47.6531 75.8019 43.7431 77.9419 39.3531 78.7219C34.9531 79.5119 30.0731 78.9219 25.8731 78.2019C21.6731 77.4919 18.1631 76.6419 15.3631 74.9819C12.5631 73.3219 10.4831 70.8519 8.1631 67.8919C5.8531 64.9219 3.3131 61.4719 2.0031 57.5319C0.693098 53.5919 0.603098 49.1719 0.863098 44.0919C1.1231 39.0119 1.7331 33.2819 2.5931 28.1119C3.4431 22.9319 4.5531 18.3119 6.3431 14.5019C8.1331 10.6919 10.6131 7.70194 13.7031 5.48194C16.7931 3.27194 20.5031 1.84194 24.1831 1.15194Z"
        fill="white"
        stroke="black"
        strokeWidth="1.5"
        strokeMiterlimit="2.61313"
        strokeDasharray="4.5 2.7"
      />
    </svg>
  )
}
